import { Component, computed, input } from '@angular/core';

import { TellentMember } from '@core/tellent-types';
import { resolveMemberFullName, resolveMemberInitials } from '@core/tellent-util';
import { AvatarComponent } from '@core/user-interface-legacy';

type Member = Pick<TellentMember, 'email' | 'firstName' | 'lastName'>;

@Component({
  selector: 'tlc-member-avatar',
  imports: [AvatarComponent],
  templateUrl: './member-avatar.component.html',
  styleUrl: './member-avatar.component.less',
  providers: [],
})
export class MemberAvatarComponent {
  public member = input.required<Member>();

  public initials = computed(() => {
    const { firstName, lastName, email } = this.member();
    return resolveMemberInitials({ firstName, lastName, email }).toUpperCase();
  });

  public memberName = computed(() => {
    const { firstName, lastName, email } = this.member();
    return resolveMemberFullName({ firstName, lastName, email });
  });
}
